import React, {useCallback} from "react";
import classNames from "classnames";
import {isMobileOnly} from "react-device-detect";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './Footer.scss';

const Footer = () => {

	const sendGa1 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"푸터-미니맵에광고하기"
		});
	}, []);
	const sendGa2 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"미니맵-홈",
			label:"푸터-미니맵유저만나기"
		});
	}, []);
	const sendGa3 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"미니맵-가입",
			label:"푸터-미니맵가입하기"
		});
	}, []);
	const sendGa4 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"미니맵-문의",
			label:"푸터-문의하기"
		});
	}, []);


	return (
		<div id="footer" className="bc_03 view_section">
			<div className={classNames("footer_wrap", "lc_1f")}>
				<div className={classNames("title", "c_light_blue_2")}>
					{
						isMobileOnly ? 
						textMap.formatString(textMap.footer_title_mobile, <span className={classNames("footer_tag", "c_blue", "cbc_dark_blue_2")}>{textMap.footer_title_2}</span>) :
						textMap.formatString(textMap.footer_title, <span className={classNames("footer_tag", "c_blue", "cbc_dark_blue_2")}>{textMap.footer_title_2}</span>)
					}
				</div>
				<div className="button_wrap">
					<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa1}>
						<span className={classNames("button", "cbc_blue", "c_ff", "sc_blue")}>{textMap.footer_button}</span>
					</a>
				</div>
			</div>
			<div className={classNames("footer_info", "c_4a")}>
				<span className={classNames("left_text")}>
					© Copyright 2020 <span style={{fontWeight:700}}>minimap</span>
				</span>
				<span className="right_text">
					<span className="footer_button"><a href="https://minimap.net" target="_blank" rel="noopener noreferrer" onClick={sendGa2}>{textMap.footer_button_1}</a></span>
					<span className="footer_button"><a href="https://minimap.net/auth/register" target="_blank" rel="noopener noreferrer" onClick={sendGa3}>{textMap.footer_button_2}</a></span>
					<span className="footer_button"><a href="https://minimap.net/auth/help" target="_blank" rel="noopener noreferrer" onClick={sendGa4}>{textMap.footer_button_3}</a></span>
				</span>
			</div>
		</div>
	);
};

export default Footer;
